const TOKEN_KEY = 'mid_trader_token';

function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

function authHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function redirectToLogin() {
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
}

async function request(url, options = {}) {
  const config = { ...options };
  config.headers = {
    ...authHeaders(),
    ...(config.headers || {}),
  };

  if (config.body && !config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(url, config);
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      console.warn('Resposta não pôde ser convertida em JSON');
    }
  }

  if (response.status === 401) {
    redirectToLogin();
    throw new Error(data?.error || 'Sessão expirada');
  }

  if (!response.ok) {
    const message = data?.error || response.statusText || 'Erro desconhecido';
    throw new Error(message);
  }

  return data;
}

export const login = (email, password) =>
  request('/api/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
    headers: { 'Content-Type': 'application/json' },
  });

export const fetchTickers = () => request('/api/tickers');
export const fetchBalances = () => request('/api/balances');

export const fetchOrderbook = (symbol) =>
  request(`/api/futures/${encodeURIComponent(symbol)}/orderbook`);
export const fetchTrades = (symbol) =>
  request(`/api/futures/${encodeURIComponent(symbol)}/trades`);
export const fetchOpenOrders = (symbol) =>
  request(`/api/futures/${encodeURIComponent(symbol)}/open-orders`);
export const submitFuturesOrder = (symbol, payload) =>
  request(`/api/futures/${encodeURIComponent(symbol)}/orders`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const submitSpotOrder = (payload) =>
  request('/api/spot/orders', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
